import styled from 'styled-components';
import media from '../../../styled/media';

export const Intro = styled.div`
  position: relative;
`;

export const Heading = styled.h1`
  font-weight: 400;
  font-size: 32px;
  text-align: center;
  ${media.tablet`
    font-size: 48px;
    line-height: 58px;
    text-align: inherit;
  `}
`;

export const IntroTextContainer = styled.div`
  padding: 32px 0;
  ${media.tablet`
    max-width: 50%;
    padding: 210px 40px 210px 0;
  `}
`;

export const IntroImageContainer = styled.div`
  ${media.tablet`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 50%;
  `}
`;

export const FactsWrapper = styled.div`
  background: #f5f5f5;
  padding: 40px 0;
  ${media.tablet`
    padding: 72px 0;
  `}
`;

export const FactsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${media.tablet`
    flex-direction: row;
    gap: 64px;
  `}
`;

export const FactsListItem = styled.p`
  text-align: center;
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  ${media.tablet`
    font-size: 17px;
    line-height: 27px;
    flex: 1;
  `}
`;

export const StoryInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  ${media.tablet`
    padding: 96px 0;
  `}
`;

export const StoryText = styled.p`
  margin: 0 0 24px;
  q {
    font-style: italic;
    padding: 4px 0 0 16px;
    display: block;
    ${media.tablet`
      padding-left: 40px;
    `}
  }
`;

export const VisitWrapper = styled.div`
  background: #f5f5f5;
  text-align: center;
  padding: 40px 0;
  ${media.tablet`
    padding: 96px 0;
  `}
`;

export const VisitHeading = styled.h6`
  margin: 0 0 32px;
  font-weight: 400;
  font-size: 24px;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const VisitDescription = styled.p`
  margin: 32px 0 0;
  font-size: 18px;
  ${media.tablet`
    font-size: 24px;
    line-height: 32px;
    margin: 32px 64px 0;
  `}
`;
